export const webLoginStoragekey = "webLoginKeyAndToken";
export const CountDownTime = 30;
